import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Language, SelectedLanguage } from '@app/shared/models/language';
import { LanguageService } from '@app/shared/services/language.service';

@Component({
	selector: 'kpa-switchlanguages',
	templateUrl: './switchlanguages.component.html',
	styleUrl: './switchlanguages.component.scss',
})
export class SwitchlanguagesComponent {
	@Input() dialogOpened: boolean = false;
	@Output() dialogOpenedChange: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() setLanguage: SelectedLanguage
	@Output() closeDialog = new EventEmitter();
	selectedLanguage: SelectedLanguage;
	isResetTrainingsEnabled: boolean = false;
	constructor(
		private readonly languageService: LanguageService
	) {}

	public open(component: string): void {
		this[component + 'Opened'] = true;
	}

	public switchLanguage() {
		this.dialogOpenedChange.emit(this.isResetTrainingsEnabled);
		this.dialogOpened = false;
	}

	public close(component: string): void {
		
		this[component + 'Opened'] = false;
		this.isResetTrainingsEnabled = false;
		this.closeDialog.emit();
		location.reload();
	}
}
